import * as queryString from 'query-string';

export namespace SignInUrlBuilder {
  export enum QueryKey {
    redirect = 'redirect', // path!
    error = 'error',
    externalRedirect = 'externalRedirect',
    site = 'site',
    target_site = 'target_site', // desktop sign in populates the target_site query parameter
    closePopupWhenDone = 'closePopupWhenDone',
    passwordResetSuccess = 'passwordResetSuccess',
    disableAppBanner = 'disableAppBanner',
    deepLinkingDisabled = ':deepLinkingDisabled',
    client_type = 'client_type',
    disableAutoSignin = 'disableAutoSignin',
    auth = 'auth', // Overrides the auth type in Online to do username+password.
    forceSitePick = 'forceSitePick',
    isDefaultIdentityPoolLogin = 'isDefaultIdentityPoolLogin', // Shows the legacy login page when identity pools is enabled.
    clientAppId = 'clientAppId', // Tableau Connected App Client ID used to filter to sites that the App is enabled on
  }

  type QueryKeyValue<T extends QueryKey> =
    T extends 'disableAutoSignin' ? boolean :
    T extends 'passwordResetSuccess' ? boolean :
    T extends 'disableAppBanner' ? boolean :
    T extends ':deepLinkingDisabled' ? boolean :
    T extends 'closePopupWhenDone' ? boolean :
    T extends 'forceSitePick' ? boolean :
    T extends 'isDefaultIdentityPoolLogin' ? boolean :
    T extends 'error' ? number :
    string;

  export type QueryParams = {
    [P in QueryKey]?: QueryKeyValue<P> | null;
  };

  export function buildQuery(queryParams: QueryParams): string {
    const query = Object.entries(queryParams).reduce((prevValue, currentValue) => {
      if (typeof currentValue[1] === 'boolean') {
        return (prevValue ? prevValue + '&' : '') + currentValue[0] + '=' + (currentValue[1] ? 'yes' : 'no');

      } else if (currentValue[1]) {
        return (prevValue ? prevValue + '&' : '') + currentValue[0] + '=' + encodeURIComponent(currentValue[1]);
      }

      return prevValue;
    }, '');

    return query;
  }

  export function queryParamsFromQuery(query: string): QueryParams {
    let params = queryString.parse(query);
    (Object.keys(params) as QueryKey[]).forEach(key => {
      const val: string = params[key];

      if (key === QueryKey.error) { // convert number types to `number`
        params[key] = +val;
      } else if ( // convert boolean types to `boolean`
        key === QueryKey.disableAutoSignin
        || key === QueryKey.passwordResetSuccess
        || key === QueryKey.disableAppBanner
        || key === QueryKey.deepLinkingDisabled
        || key === QueryKey.closePopupWhenDone
        || key === QueryKey.forceSitePick
        || key === QueryKey.isDefaultIdentityPoolLogin
      ) {
        params[key] = BooleanQueryParamRegex.test(val);
      } else {
        params[key] = val;
      }
    });
    return params;
  }

  // Taken from httpd.conf (.*(?:\:|\%3A)embed=(y|yes|t|true|1).*)
  const BooleanQueryParamRegex = /^[yt1]/i;
}
